import React,{useState} from 'react'
import Title from '../../../components/panelcontrols/paneltitle'
import './index.css'
import Table from './accountsTable'

const Index = () => {
    const [list] = useState([]);
  return (
    <div className='labadmin_accounts_container'>
        <Title Value={'Accounts'}/>
        <Table List={list}/>
    </div>
  )
}

export default Index
